module.exports = __webpack_public_path__ + "static/american-dirt-0d337b8357091f5660f07e9808ad79f4.jpg";